import React, { useState, useEffect } from "react";
import axios from "axios";
import { Row, Col } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

const API_URL = "https://subk.education.com.ly/back/api/construction-expenses";
const ACCOUNTS_URL = "https://subk.education.com.ly/back/api/accounts";

function ConstructionExpensesPage() {
  const navigate = useNavigate(); // Use useNavigate hook for navigation

   ///////////////////////////////////////////////////////////
   const userPermissionsJSON = localStorage.getItem('USER_PERMISSIONS2');
  const userPermissions = JSON.parse(userPermissionsJSON);
   function getActionsForPage(pageName) {
    const pagePermissions = userPermissions.find(permission => permission.resource === pageName);
    console.log('actionsForPage', pagePermissions);
    if (pagePermissions) {
      return pagePermissions.action;
    } else {
      navigate('/dashboard_1');
      return [];
    }
  }

  const pageName = 'ConstructionExpensesPage';
  const actionsForPage = getActionsForPage(pageName);

///////////////////////////////////
  const [expenses, setExpenses] = useState([]);
  const [accounts, setAccounts] = useState([]);
    const userdata = localStorage.getItem('USER_data');
    const userData = JSON.parse(userdata);
    const userid = userData.id;
  const [form, setForm] = useState({
    ExpenseDate: "",
    AccountID: "",
    Amount: "",
    Description: "",
    UserID:userid,
      PaymentMethod:'',

  });
  
     useEffect(() => {
        if (userid) {
          setForm((prevData) => ({
            ...prevData,
            UserID: userid,
          }));
        }
      }, [userid]);
  // تحميل المصاريف
  useEffect(() => {
    fetchExpenses();
    fetchAccounts();
  }, []);

  const fetchExpenses = async () => {
    try {
      const res = await axios.get(API_URL);
      setExpenses(res.data);
    } catch (err) {
      console.error("Error fetching expenses", err);
    }
  };

  const fetchAccounts = async () => {
    try {
      const res = await axios.get(ACCOUNTS_URL);
      setAccounts(res.data);
    } catch (err) {
      console.error("Error fetching accounts", err);
    }
  };

  // التعامل مع إدخال البيانات
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

 const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingId) {
        await axios.put(`${API_URL}/${editingId}`, form);
      } else {
        await axios.post(API_URL, form);
      }
      setForm({   ExpenseDate: "", Amount: "", Description: "", AccountID: "", UserID:userid ,
      PaymentMethod:'',});
      setEditingId(null);
      fetchExpenses();
    } catch (err) {
      console.error(err);
      alert("حدث خطأ أثناء حفظ البيانات");
    }
  };
  const [editingId, setEditingId] = useState(null);
  // Edit button
  const handleEdit = (expense) => {
    setForm({
       ExpenseDate: expense.ExpenseDate,
      Amount: expense.Amount,
      Description: expense.Description,
      AccountID: expense.AccountID
    });
    setEditingId(expense.ExpenseID);
  };
const handleFinalize = async () => {
  try {
    await axios.post("https://subk.education.com.ly/back/api/construction-expenses/finalize", form);
    alert("تم تحويل المصاريف إلى أصل ثابت بنجاح!");
    fetchExpenses(); // لتحديث الجدول بعد الترحيل
  } catch (err) {
    console.error(err);
    alert("حدث خطأ أثناء الترحيل");
  }
};
  return (
    <div className="container-fluid">
      <Row>
        <Col lg="12">
          <div className="card p-3">
            <h4 className="mb-3">📑 مصاريف الإنشاء</h4>
<button className="btn btn-success btn-sm mb-3" onClick={() => handleFinalize()}>
  تحويل إلى أصل ثابت
</button>
            {/* فورم الإضافة */}
            <form onSubmit={handleSubmit} className="row g-3 mb-4">
              <div className="col-md-2">
                <input
                  type="date"
                  name="ExpenseDate"
                  value={form.ExpenseDate}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </div>
              <div className="col-md-2">
                <select
                  name="AccountID"
                  value={form.AccountID}
                  onChange={handleChange}
                  className="form-control"
                  required
                >
                  <option value="">-- اختر الحساب --</option>
                  {accounts.map((acc) => (
                    <option key={acc.AccountID} value={acc.AccountID}>
                      {acc.AccountName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-2">
                <input
                  type="number"
                  step="0.01"
                  name="Amount"
                  value={form.Amount}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="المبلغ"
                  required
                />
              </div>
              <div className="col-md-2">
                <input
                  type="text"
                  name="Description"
                  value={form.Description}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="الوصف"
                />
              </div>
              <div className="col-md-2 mt-3 ">
                                         <select
                                            className="form-control"
                                            name="PaymentMethod"
                                            required
                                          defaultValue= {form.PaymentMethod} onChange={handleChange}
                                        >
                                            <option value="" >اختر طريقة الدفع</option>
                                            <option value="cash">كاش</option>
                                            <option value="card">بطاقة</option>
                                        </select>
                                    </div>
            <div className="col-md-2 d-flex gap-1">
  <button type="submit" className="btn btn-primary btn-sm">
    {editingId ? "تحديث" : "إضافة"}
  </button>
  {editingId && (
    <button
      type="button"
      className="btn btn-danger btn-sm"
      onClick={() => {
        setForm({ ExpenseDate: "", Amount: "", Description: "", AccountID: "" });
        setEditingId(null);
      }}
    >
       إلغاء
    </button>
  )}
</div>

            </form>

            {/* جدول المصاريف */}
            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead className="table-dark text-center">
                  <tr>
                    <th>#</th>
                    <th>التاريخ</th>
                    <th>الحساب</th>
                    <th>المبلغ</th>
                    <th>الوصف</th>
                                        <th>الإجراءات</th>

                  </tr>
                </thead>
                <tbody>
                  {expenses.length > 0 ? (
                    expenses.map((exp) => (
                      <tr key={exp.ExpenseID}>
                        <td>{exp.ExpenseID}</td>
                        <td>{exp.ExpenseDate}</td>
                        <td>{exp.account?.AccountName || "-"}</td>
                        <td>{exp.Amount}</td>
                        <td>{exp.Description}</td>
                        <td>
                 <i onClick={() => handleEdit(exp)} style={{color:'green'}} class="fa-lg fa-solid fa-pen-to-square" hidden={editingId}></i>
              </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        لا توجد مصاريف بعد
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default ConstructionExpensesPage;
